import React, { useEffect, useState } from "react";
import { Route, Switch, useParams, useRouteMatch, Redirect } from "react-router-dom";
import { Channel, Socket } from "components/Comet";
import currentEventAction from "actions/currentEvent";
import EventInfo from "./Info";
import EventStatistic from "./Statistic";
import StatisticStreamWatch from "./Statistic/StreamWatch";
import EpisodeClientsStatistic from "./Statistic/EpisodeClients";
import EventEmbedCode from "./EmbedCode";
import EventTickets from "./Tickets";
import ClientStatistic from "./ClientStatistic";
import Comments from "./Comments";
import Questions from "./Questions";
import PagePoll from "./PagePoll";
import PageRecords from "./PageRecords";
import PageBanners from "./PageBanners";
import ClientCertificate from "./ClientCertificate";
import RemindersPage from "./RemindersPage";
import PasswordEmailSettingsPage from "./PasswordEmailSettingsPage";
import EventRegistrationEmailSettingsPage from "./EventRegistrationEmailSettingsPage";
import EventAccessAllowedEmailSettingsPage from "./EventAccessAllowedEmailSettingsPage";
import TicketEmailSettingsPage from "./TicketEmailSettingsPage";
import EmailSettingsGlobal from "./EmailSettingsGlobal";
import EventAuthEmails from "./AllowedEmails";
import EventAccessPreModeration from "./EventAccessPreModeration";
import PresenceCheckPage from "./PresenceCheckPage";
import Loading from "components/Loading";
import tokenStorage from "../../../player/js/tokenStorage";
import { getCometServers, getEvent } from "api";
import "./style.less";
import { connect } from "react-redux";
import { ClientProvider, EventContext } from "../../context";
import PageLayout from "../PageLayout";
import StatisticPolls from "./Statistic/Polls";
import StatisticNotifications from "./Statistic/Notifications";
import StatisticBanners from "./Statistic/Banners";
import StatisticActivityTop from "./Statistic/ActivityTop";
import StatisticDownload from "./Statistic/Download";
import StatisticShop from "./Statistic/Shop";
import EpisodesPage from "./EpisodesPage";
import OfflinePage from "./OfflinePage";
import Reminders from "./Reminders";
import ReminderEditPage from "./Reminders/edit";
import ReminderStatistics from "./Reminders/statistics";
import ReminderRecipientsStatictics from "./Reminders/recipientsList";
import WidgetNewRegistration from "./Widgets/NewRegistration";
import WidgetRegistration from "./Widgets/Registration";
import BlockConstructor from "./BlockConstructor";
import LettersConstructor from "./LettersConstructor";
import LetterTemplate from "./LettersConstructor/LetterTemplate";
import QuizPage from "./QuizPage";
import BrandingSettings from "./EventSettings/BrandingSettings";
import LoginAndRegistrationPageSettings from "./PagesSettings/pages/LoginAndRegistrationPage";
import PagesSettings from "./PagesSettings";
import EventCalendarSettings from "./EventCalendarSettings";
import Participants from "./Participants";
import WidgetEditor from "./Widgets/NewRegistration/pages/WidgetEditor";
import WidgetScheduleConstructor from './Widgets/Schedule/WidgetScheduleConstructor';
import WidgetScheduleEditor from './Widgets/Schedule/WidgetScheduleEditor';
import SchedulePdfConstructorPage from "./SchedulePdfConstructorPage";
import WidgetMembersCreator from "./Widgets/Members/WidgetMembersCreator";
import WidgetMembersEditor from "./Widgets/Members/WidgetMembersEditor";
import WidgetBroadcast from "./Widgets/Broadcast";
import WidgetBroadcastEditor from "./Widgets/Broadcast/Editor";
import ManagePollResultPage from "./ManagePollResultPage";
import QuestionSettings from "./Questions/QuestionSettings";
import AuthorizationSettings from "./EventSettings/AuthorizationSettings";
import CommonSettings from "./EventSettings/CommonSettings";
import PlayerSettings from "./EventSettings/PlayerSettings";
import EnablingModules from "./EventSettings/EnablingModules";
import { ModuleSettingsProvider } from "../../context";
import PrizesShop from "./PrizesShop";
import EventNotifications from "./EventNotifications";
import StatisticQuizzes from "./Statistic/Quizzes";
import ViewingRestrictionSettings from "./EventSettings/ViewingRestrictionSettings";

const EventPageComponent = ({ event, cometServers, cometChannels }) => {
    let { path } = useRouteMatch();

    if (!event) {
        return null;
    }

    return (
        <Socket servers={cometServers}>
            {cometChannels.map((cometChannel) => (
                <Channel key={cometChannel} name={cometChannel} />
            ))}
            <Switch>
                <Route
                    path={`${path}/event-setting/common`}
                    exact
                    component={CommonSettings}
                />
                <Route
                    path={`${path}/event-setting/branding`}
                    exact
                    component={BrandingSettings}
                />
                <Route
                    path={`${path}/event-setting/authorization`}
                    exact
                    component={AuthorizationSettings}
                />
                <Route
                    path={`${path}/event-setting/viewing-restriction`}
                    exact
                    component={ViewingRestrictionSettings}
                />
                <Route
                    path={`${path}/event-setting/player-settings`}
                    exact
                    component={PlayerSettings}
                />
                <Route
                    path={`${path}/event-setting/enabling-modules`}
                    exact
                    component={EnablingModules}
                />
                <Route
                    path={`${path}/event-setting/login-and-registration`}
                    exact
                    component={LoginAndRegistrationPageSettings}
                />
                <Route path={`${path}`} exact component={EventInfo} />
                <Route
                    path={`${path}/offline`}
                    component={OfflinePage}
                />
                <Route
                    path={`${path}/episodes`}
                    component={EpisodesPage}
                />
                <Route
                    path={`${path}/schedule-pdf-constructor`}
                    exact
                    component={SchedulePdfConstructorPage}
                />
                <Route
                    path={`${path}/participants`}
                    component={Participants}
                />
                <Route
                    path={`${path}/tickets`}
                    exact
                    component={EventTickets}
                />
                <Route
                    path={`${path}/accessByEmails`}
                    exact
                    component={EventAuthEmails}
                />
                <Route
                    path={`${path}/accessPreModeration`}
                    exact
                    component={EventAccessPreModeration}
                />
                <Route
                    path={`${path}/statistic`}
                    exact
                    component={EventStatistic}
                />
                <Route
                    path={`${path}/statistic/stream/:type`}
                    component={StatisticStreamWatch}
                />
                <Route
                    path={`${path}/statistic/episode/:episodeKey/clients`}
                    exact
                    component={EpisodeClientsStatistic}
                />
                <Route
                    path={`${path}/statistic/polls`}
                    component={StatisticPolls}
                />
                <Route
                    path={`${path}/statistic/quizzes`}
                    component={StatisticQuizzes}
                />
                <Route
                    path={`${path}/statistic/notifications`}
                    component={StatisticNotifications}
                />
                <Route
                    path={`${path}/statistic/banners`}
                    component={StatisticBanners}
                />
                <Route
                    path={`${path}/statistic/activityTop`}
                    component={StatisticActivityTop}
                />
                {event.moduleShop?.enabled && <Route
                    path={`${path}/statistic/shop`}
                    component={StatisticShop}
                />}
                <Route
                    path={`${path}/statistic/download`}
                    component={StatisticDownload}
                />
                <Route
                    path={`${path}/client/:clientId`}
                    exact
                    component={ClientStatistic}
                />
                <Route
                    path={`${path}/reminders`}
                    exact
                    component={RemindersPage}
                />
                <Route
                    path={`${path}/emailSettings/globalSettings`}
                    exact
                    component={EmailSettingsGlobal}
                />
                <Route
                    path={`${path}/emailSettings/password`}
                    exact
                    component={PasswordEmailSettingsPage}
                />
                <Route
                    path={`${path}/emailSettings/eventRegistration`}
                    exact
                    component={EventRegistrationEmailSettingsPage}
                />
                <Route
                    path={`${path}/emailSettings/eventAccessAllowed`}
                    exact
                    component={EventAccessAllowedEmailSettingsPage}
                />
                <Route
                    path={`${path}/emailSettings/ticket`}
                    exact
                    component={TicketEmailSettingsPage}
                />
                <Route
                    path={`${path}/emailSettings/constructor`}
                    exact
                    component={LettersConstructor}
                />
                <Route
                    path={`${path}/emailSettings/constructor/create`}
                    exact
                    component={LetterTemplate}
                />
                <Route
                    path={`${path}/emailSettings/constructor/:templateId`}
                    exact
                    component={LetterTemplate}
                />
                <Route
                    path={`${path}/emailSettings/blocks`}
                    exact
                    component={BlockConstructor}
                />
                <Route
                    path={`${path}/interactive/questions`}
                    exact
                    component={Questions}
                />
                <Route
                    path={`${path}/interactive/questions/settings`}
                    exact
                    component={QuestionSettings}
                />
                <Route
                    path={`${path}/interactive/pollsAndVoting`}
                    exact
                    component={PagePoll}
                />
                <Route
                    path={`${path}/interactive/managePollResult/:pollType/:pollId`}
                    exact
                    component={ManagePollResultPage}
                />
                <Route
                    path={`${path}/interactive/quiz`}
                    component={QuizPage}
                />
                <Route
                    path={`${path}/interactive/presenceCheck`}
                    exact
                    component={PresenceCheckPage}
                />
                <Route
                    path={`${path}/interactive/banners`}
                    exact
                    component={PageBanners}
                />
                <Route path={`${path}/interactive/chats`} exact component={Comments} />
                <Route path={`${path}/interactive/shop`} exact component={PrizesShop} />
                <Route path={`${path}/interactive/eventNotifications`} exact component={EventNotifications} />
                <Route path={`${path}/records`} exact component={PageRecords} />
                <Route
                    path={`${path}/client_certificate`}
                    component={ClientCertificate}
                />
                <Route
                    path={`${path}/edit-reminders`}
                    exact
                    component={Reminders}
                />
                <Route
                    path={`${path}/edit-reminders/statistics/details/:reminderId`}
                    exact
                    component={ReminderStatistics}
                />
                <Route
                    path={`${path}/edit-reminders/statistics-recipients/:reminderId`}
                    exact
                    component={ReminderRecipientsStatictics}
                />
                <Route
                    path={`${path}/edit-reminders/:templateId/:reminderId`}
                    exact
                    component={ReminderEditPage}
                />
                <Route
                    path={`${path}/widgets/player`}
                    exact
                    component={EventEmbedCode}
                />
                <Route
                    path={`${path}/widgets/registration`}
                    exact
                    component={WidgetRegistration}
                />

                {/* Widget player */}
                <Route
                    path={`${path}/widgets/broadcast`}
                    exact
                    component={WidgetBroadcast}
                />
                <Route
                    path={`${path}/widgets/broadcast/:widgetKey`}
                    exact
                    component={WidgetBroadcastEditor}
                />
                <Route
                    path={`${path}/widgets/broadcast/edit/:widgetKey`}
                    exact
                    component={WidgetBroadcastEditor}
                />

                {/* Widget registration */}
                <Route
                    path={`${path}/widgets/new-registration`}
                    exact
                    component={WidgetNewRegistration}
                />
                <Route
                    path={`${path}/widgets/new-registration/:widgetKey`}
                    exact
                    component={WidgetEditor}
                />
                <Route
                    path={`${path}/widgets/new-registration/edit/:widgetKey`}
                    exact
                    component={WidgetEditor}
                />

                {/* Widget program */}
                <Route
                    path={`${path}/widgets/program`}
                    exact
                    component={WidgetScheduleConstructor}
                />
                <Route
                    path={`${path}/widgets/program/:widgetKey`}
                    exact
                    component={WidgetScheduleEditor}
                />
                <Route
                    path={`${path}/widgets/program/edit/:widgetKey`}
                    exact
                    component={WidgetScheduleEditor}
                />

                {/* Widget Members */}
                <Route
                    path={`${path}/widgets/members`}
                    exact
                    component={WidgetMembersCreator}
                />
                <Route
                    path={`${path}/widgets/members/:widgetKey`}
                    exact
                    component={WidgetMembersEditor}
                />
                <Route
                    path={`${path}/widgets/members/edit/:widgetKey`}
                    exact
                    component={WidgetMembersEditor}
                />

                <Route
                    path={`${path}/calendar-settings`}
                    exact
                    component={EventCalendarSettings}
                />

                {/* Pages settings */}
                <Route
                    path={`${path}/pages`}
                    render={(props) => (
                        event.moduleBranding.pagesEnabled ? <PagesSettings /> : <Redirect to={`/event/${props.match.params.eventPassword}`} />
                    )}
                />
            </Switch>
        </Socket>
    );
};

const mapStateToProps = (store) => {
    return {
        event: store.currentEvent,
    };
};

const EventPageContainer = connect(mapStateToProps)(EventPageComponent);

export default () => {
    const [event, setEvent] = useState(null);
    const [eventLoading, setEventLoading] = useState(true);
    const [cometServers, setCometServers] = useState(null);
    const [lectorCommentId, setLectorCommentId] = useState(null);
    const [lectorQuestionId, setLectorQuestionId] = useState(null);
    let { eventPassword } = useParams();

    useEffect(async () => {
        const servers = await getCometServers();
        setCometServers(servers);
    }, [eventPassword]);

    useEffect(async () => {
        if (!eventPassword) {
            setEvent(null);

            return;
        }

        setEventLoading(true);
        try {
            let event = await getEvent(eventPassword);
            setEvent(event);
        } catch (e) {
            console.error(e);
        }
        setEventLoading(false);
    }, [eventPassword]);

    useEffect(() => {
        if (event) {
            currentEventAction.setEvent(event);
            tokenStorage.setEventKey(event.eventKey);
        } else {
            currentEventAction.setEvent(null);
            tokenStorage.setEventKey(null);
        }
    }, [event]);

    if (null === event && false === eventLoading) {
        return <h4>Трансляция не найдена</h4>;
    }
    if (null === cometServers || null === event) {
        return <Loading modal>Загрузка данных трансляции...</Loading>;
    }

    const eventContext = {
        event,
        setEvent,
        lectorCommentId,
        lectorQuestionId,
        setLectorCommentId,
        setLectorQuestionId,
    };

    return (
        <EventContext.Provider value={eventContext}>
            <ModuleSettingsProvider>
                <ClientProvider>
                    <PageLayout>
                        <EventPageContainer
                            cometServers={cometServers}
                            cometChannels={[event.eventKey]}
                        />
                    </PageLayout>
                </ClientProvider>
            </ModuleSettingsProvider>
        </EventContext.Provider>
    );
};
